// Mean of the finite scores. Null when none are present, so a side nobody
// asked for (cooling score null on every condenser) stays "not applicable"
// instead of averaging in as zero.
export function averagePresentScores(
  scores: ReadonlyArray<number | null | undefined>
): number | null {
  const present = scores.filter(
    (score): score is number =>
      typeof score === 'number' && Number.isFinite(score)
  );
  if (present.length === 0) return null;
  return present.reduce((total, score) => total + score, 0) / present.length;
}
